import React from 'react';

export const Container: React.FC = ({ children }) => (
    <div className="evaluation-overview-container">{children}</div>
);
